import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import dayjs from 'dayjs';

const PrintInventoryDetails = forwardRef((props, ref) => {
  const [data, setData] = useState([]);

  const { inventoryData } = props;
  const userClaims = localStorage.getItem('UserClaims');
  const excludedKeys = ["Date", "Type", "Status", "Total"];
  let pdfExportComponent;

  const pageTemplate = (props) => {
    return (
      <>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            fontSize: "18px",
            width: '100%',
            textAlign: 'center'
          }}
        >
          Page {props.pageNum} of {props.totalPages}
        </div>
      </>
    )
  };

  const handlePrint = () => {
    if (pdfExportComponent && data.length > 0) {
      pdfExportComponent.save();
    }
  };

  useImperativeHandle(ref, () => ({
    handlePrint
  }));

  useEffect(() => {
    const modifiedArr = inventoryData.map(item =>
      item.inventoryList.map(subItem => {
        subItem.Status = subItem.status;
        subItem.Type = subItem.type;
        subItem.Date = subItem.InventoryDate;

        delete subItem.Date_Sortkey;
        delete subItem.InventoryId;
        delete subItem.InventoryDate;
        delete subItem.date;
        delete subItem.status;
        delete subItem.type;
        delete subItem.RestId;

        return subItem;
      })
    ).flat();

    setData(modifiedArr);
  }, [inventoryData]);

  return (
    <>
      <PDFExport
        paperSize="A4"
        landscape={false}
        margin="1mm"
        scale={0.56}
        ref={(pdfExport) => (pdfExportComponent = pdfExport)}
        pageTemplate={pageTemplate}
        fileName={'InventoryHistory'}
        repeatHeaders={true}
      >
        <section className="form-section">
          <div style={{ justifyContent: "center" }}>
            <div>
              <div className="banner">
                <img style={{ width: "100%" }} src="./items.png" />
                <div className="banner-content">
                  <h4> {JSON.parse(userClaims)?.restaurent_name}</h4>
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <h4>
                      Printed:{" "}
                      <span style={{ fontSize: "20px" }}>
                        {dayjs().format('MM/DD/YYYY hh:mmA')}
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="form-container">
                <div className="form-body">
                  <div class="print-table-container" style={{ marginBottom: '15px' }}>
                    <table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Status</th>
                          {data.length > 0 && Object.keys(data[0])
                            ?.filter(item => !['Date', 'Type', 'Status', 'Total']?.includes(item))
                            ?.map((item, i) => <th key={i}>{item}</th>)
                          }
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 && data?.map((item, i) =>
                          <tr key={i}>
                            <td>{item.Date}</td>
                            <td>{item.Type}</td>
                            <td>{item.Status}</td>
                            {Object.values(
                              Object.fromEntries(
                                Object.entries(item).filter(([key]) => !excludedKeys.includes(key))
                              ))?.map(item2 => <td>{item2}</td>)
                            }
                            <td>{item.Total}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </PDFExport>
    </>
  );
});

export default PrintInventoryDetails;
